import { ActionTypes } from "../constants/action-types"

export const setPlayStatus =(value) => {
    return{
        type: ActionTypes.SET_PLAY,
        payload: value,
    }
}